import usePagination from "../hooks/usePagination";

import NFTCard from "./NFTCard";
import PageNumbers from "./PageNumbers";

export default function Gallery({ itemsPerPage = 6, items }) {
	const { page, totalPages } = usePagination({ itemsPerPage, totalItems: items.length });
	const currentItems = items.slice((page - 1) * itemsPerPage, page * itemsPerPage);

	return (
		<div className="w-full">
			{totalPages > 1 && (
				<div className="flex flex-col mb-10 justify-items-center">
					<div className="flex flex-row items-center justify-center">
						<PageNumbers page={page} totalPages={totalPages} />
					</div>
				</div>
			)}
			<div className="grid grid-cols-2 auto-rows-fr auto-cols-fr gap-6 justify-items-center">
				{currentItems.map((item, index) => {
					return <NFTCard key={item.name} id={item.name} image={item.externalUrl} price={index * 3 + 31 * 20} />;
				})}
			</div>
		</div>
	);
}
